import React from 'react';

import type { NewCoreIconProps } from '@atlaskit/icon';
import PenIcon from '@atlaskit/icon/core/pen';
import MediaServicesAnnotateIconLegacy from '@atlaskit/icon/glyph/media-services/annotate';

export const AnnotateIcon: React.FunctionComponent<NewCoreIconProps> = (
	props: NewCoreIconProps,
) => <PenIcon {...props} label="" LEGACY_fallbackIcon={MediaServicesAnnotateIconLegacy} />;
